/**
 * Utility functions for handling country code data from Auth0 SDK
 */
const COUNTRY_DATA: Record<
  string,
  { name: string; flag: string; prefix: string }
> = {
  AD: { name: 'Andorra', flag: '🇦🇩', prefix: '376' },
  AE: { name: 'United Arab Emirates', flag: '🇦🇪', prefix: '971' },
  AF: { name: 'Afghanistan', flag: '🇦🇫', prefix: '93' },
  AG: { name: 'Antigua and Barbuda', flag: '🇦🇬', prefix: '1268' },
  AI: { name: 'Anguilla', flag: '🇦🇮', prefix: '1264' },
  AL: { name: 'Albania', flag: '🇦🇱', prefix: '355' },
  AM: { name: 'Armenia', flag: '🇦🇲', prefix: '374' },
  AO: { name: 'Angola', flag: '🇦🇴', prefix: '244' },
  AQ: { name: 'Antarctica', flag: '🇦🇶', prefix: '672' },
  AR: { name: 'Argentina', flag: '🇦🇷', prefix: '54' },
  AS: { name: 'American Samoa', flag: '🇦🇸', prefix: '1684' },
  AT: { name: 'Austria', flag: '🇦🇹', prefix: '43' },
  AU: { name: 'Australia', flag: '🇦🇺', prefix: '61' },
  AW: { name: 'Aruba', flag: '🇦🇼', prefix: '297' },
  AX: { name: 'Åland Islands', flag: '🇦🇽', prefix: '358' },
  AZ: { name: 'Azerbaijan', flag: '🇦🇿', prefix: '994' },
  BA: { name: 'Bosnia and Herzegovina', flag: '🇧🇦', prefix: '387' },
  BB: { name: 'Barbados', flag: '🇧🇧', prefix: '1246' },
  BD: { name: 'Bangladesh', flag: '🇧🇩', prefix: '880' },
  BE: { name: 'Belgium', flag: '🇧🇪', prefix: '32' },
  BF: { name: 'Burkina Faso', flag: '🇧🇫', prefix: '226' },
  BG: { name: 'Bulgaria', flag: '🇧🇬', prefix: '359' },
  BH: { name: 'Bahrain', flag: '🇧🇭', prefix: '973' },
  BI: { name: 'Burundi', flag: '🇧🇮', prefix: '257' },
  BJ: { name: 'Benin', flag: '🇧🇯', prefix: '229' },
  BL: { name: 'Saint Barthélemy', flag: '🇧🇱', prefix: '590' },
  BM: { name: 'Bermuda', flag: '🇧🇲', prefix: '1441' },
  BN: { name: 'Brunei Darussalam', flag: '🇧🇳', prefix: '673' },
  BO: { name: 'Bolivia, Plurinational State of', flag: '🇧🇴', prefix: '591' },
  BQ: { name: 'Bonaire, Sint Eustatius and Saba', flag: '🇧🇶', prefix: '599' },
  BR: { name: 'Brazil', flag: '🇧🇷', prefix: '55' },
  BS: { name: 'Bahamas', flag: '🇧🇸', prefix: '1242' },
  BT: { name: 'Bhutan', flag: '🇧🇹', prefix: '975' },
  BV: { name: 'Bouvet Island', flag: '🇧🇻', prefix: '47' },
  BW: { name: 'Botswana', flag: '🇧🇼', prefix: '267' },
  BY: { name: 'Belarus', flag: '🇧🇾', prefix: '375' },
  BZ: { name: 'Belize', flag: '🇧🇿', prefix: '501' },
  CA: { name: 'Canada', flag: '🇨🇦', prefix: '1' },
  CC: { name: 'Cocos (Keeling) Islands', flag: '🇨🇨', prefix: '61' },
  CD: {
    name: 'Congo, the Democratic Republic of the',
    flag: '🇨🇩',
    prefix: '243',
  },
  CF: { name: 'Central African Republic', flag: '🇨🇫', prefix: '236' },
  CG: { name: 'Congo', flag: '🇨🇬', prefix: '242' },
  CH: { name: 'Switzerland', flag: '🇨🇭', prefix: '41' },
  CI: { name: "Côte d'Ivoire", flag: '🇨🇮', prefix: '225' },
  CK: { name: 'Cook Islands', flag: '🇨🇰', prefix: '682' },
  CL: { name: 'Chile', flag: '🇨🇱', prefix: '56' },
  CM: { name: 'Cameroon', flag: '🇨🇲', prefix: '237' },
  CN: { name: 'China', flag: '🇨🇳', prefix: '86' },
  CO: { name: 'Colombia', flag: '🇨🇴', prefix: '57' },
  CR: { name: 'Costa Rica', flag: '🇨🇷', prefix: '506' },
  CU: { name: 'Cuba', flag: '🇨🇺', prefix: '53' },
  CV: { name: 'Cape Verde', flag: '🇨🇻', prefix: '238' },
  CW: { name: 'Curaçao', flag: '🇨🇼', prefix: '599' },
  CX: { name: 'Christmas Island', flag: '🇨🇽', prefix: '61' },
  CY: { name: 'Cyprus', flag: '🇨🇾', prefix: '357' },
  CZ: { name: 'Czech Republic', flag: '🇨🇿', prefix: '420' },
  DE: { name: 'Germany', flag: '🇩🇪', prefix: '49' },
  DJ: { name: 'Djibouti', flag: '🇩🇯', prefix: '253' },
  DK: { name: 'Denmark', flag: '🇩🇰', prefix: '45' },
  DM: { name: 'Dominica', flag: '🇩🇲', prefix: '1767' },
  DO: { name: 'Dominican Republic', flag: '🇩🇴', prefix: '1809' },
  DZ: { name: 'Algeria', flag: '🇩🇿', prefix: '213' },
  EC: { name: 'Ecuador', flag: '🇪🇨', prefix: '593' },
  EE: { name: 'Estonia', flag: '🇪🇪', prefix: '372' },
  EG: { name: 'Egypt', flag: '🇪🇬', prefix: '20' },
  EH: { name: 'Western Sahara', flag: '🇪🇭', prefix: '212' },
  ER: { name: 'Eritrea', flag: '🇪🇷', prefix: '291' },
  ES: { name: 'Spain', flag: '🇪🇸', prefix: '34' },
  ET: { name: 'Ethiopia', flag: '🇪🇹', prefix: '251' },
  FI: { name: 'Finland', flag: '🇫🇮', prefix: '358' },
  FJ: { name: 'Fiji', flag: '🇫🇯', prefix: '679' },
  FK: { name: 'Falkland Islands (Malvinas)', flag: '🇫🇰', prefix: '500' },
  FM: { name: 'Micronesia, Federated States of', flag: '🇫🇲', prefix: '691' },
  FO: { name: 'Faroe Islands', flag: '🇫🇴', prefix: '298' },
  FR: { name: 'France', flag: '🇫🇷', prefix: '33' },
  GA: { name: 'Gabon', flag: '🇬🇦', prefix: '241' },
  GB: { name: 'United Kingdom', flag: '🇬🇧', prefix: '44' },
  GD: { name: 'Grenada', flag: '🇬🇩', prefix: '1473' },
  GE: { name: 'Georgia', flag: '🇬🇪', prefix: '995' },
  GF: { name: 'French Guiana', flag: '🇬🇫', prefix: '594' },
  GG: { name: 'Guernsey', flag: '🇬🇬', prefix: '44' },
  GH: { name: 'Ghana', flag: '🇬🇭', prefix: '233' },
  GI: { name: 'Gibraltar', flag: '🇬🇮', prefix: '350' },
  GL: { name: 'Greenland', flag: '🇬🇱', prefix: '299' },
  GM: { name: 'Gambia', flag: '🇬🇲', prefix: '220' },
  GN: { name: 'Guinea', flag: '🇬🇳', prefix: '224' },
  GP: { name: 'Guadeloupe', flag: '🇬🇵', prefix: '590' },
  GQ: { name: 'Equatorial Guinea', flag: '🇬🇶', prefix: '240' },
  GR: { name: 'Greece', flag: '🇬🇷', prefix: '30' },
  GS: {
    name: 'South Georgia and the South Sandwich Islands',
    flag: '🇬🇸',
    prefix: '500',
  },
  GT: { name: 'Guatemala', flag: '🇬🇹', prefix: '502' },
  GU: { name: 'Guam', flag: '🇬🇺', prefix: '1671' },
  GW: { name: 'Guinea-Bissau', flag: '🇬🇼', prefix: '245' },
  GY: { name: 'Guyana', flag: '🇬🇾', prefix: '592' },
  HK: { name: 'Hong Kong', flag: '🇭🇰', prefix: '852' },
  HM: { name: 'Heard Island and McDonald Islands', flag: '🇭🇲', prefix: '672' },
  HN: { name: 'Honduras', flag: '🇭🇳', prefix: '504' },
  HR: { name: 'Croatia', flag: '🇭🇷', prefix: '385' },
  HT: { name: 'Haiti', flag: '🇭🇹', prefix: '509' },
  HU: { name: 'Hungary', flag: '🇭🇺', prefix: '36' },
  ID: { name: 'Indonesia', flag: '🇮🇩', prefix: '62' },
  IE: { name: 'Ireland', flag: '🇮🇪', prefix: '353' },
  IL: { name: 'Israel', flag: '🇮🇱', prefix: '972' },
  IM: { name: 'Isle of Man', flag: '🇮🇲', prefix: '44' },
  IN: { name: 'India', flag: '🇮🇳', prefix: '91' },
  IO: { name: 'British Indian Ocean Territory', flag: '🇮🇴', prefix: '246' },
  IQ: { name: 'Iraq', flag: '🇮🇶', prefix: '964' },
  IR: { name: 'Iran, Islamic Republic of', flag: '🇮🇷', prefix: '98' },
  IS: { name: 'Iceland', flag: '🇮🇸', prefix: '354' },
  IT: { name: 'Italy', flag: '🇮🇹', prefix: '39' },
  JE: { name: 'Jersey', flag: '🇯🇪', prefix: '44' },
  JM: { name: 'Jamaica', flag: '🇯🇲', prefix: '1876' },
  JO: { name: 'Jordan', flag: '🇯🇴', prefix: '962' },
  JP: { name: 'Japan', flag: '🇯🇵', prefix: '81' },
  KE: { name: 'Kenya', flag: '🇰🇪', prefix: '254' },
  KG: { name: 'Kyrgyzstan', flag: '🇰🇬', prefix: '996' },
  KH: { name: 'Cambodia', flag: '🇰🇭', prefix: '855' },
  KI: { name: 'Kiribati', flag: '🇰🇮', prefix: '686' },
  KM: { name: 'Comoros', flag: '🇰🇲', prefix: '269' },
  KN: { name: 'Saint Kitts and Nevis', flag: '🇰🇳', prefix: '1869' },
  KP: {
    name: "Korea, Democratic People's Republic of",
    flag: '🇰🇵',
    prefix: '850',
  },
  KR: { name: 'Korea, Republic of', flag: '🇰🇷', prefix: '82' },
  KW: { name: 'Kuwait', flag: '🇰🇼', prefix: '965' },
  KY: { name: 'Cayman Islands', flag: '🇰🇾', prefix: '1345' },
  KZ: { name: 'Kazakhstan', flag: '🇰🇿', prefix: '7' },
  LA: { name: "Lao People's Democratic Republic", flag: '🇱🇦', prefix: '856' },
  LB: { name: 'Lebanon', flag: '🇱🇧', prefix: '961' },
  LC: { name: 'Saint Lucia', flag: '🇱🇨', prefix: '1758' },
  LI: { name: 'Liechtenstein', flag: '🇱🇮', prefix: '423' },
  LK: { name: 'Sri Lanka', flag: '🇱🇰', prefix: '94' },
  LR: { name: 'Liberia', flag: '🇱🇷', prefix: '231' },
  LS: { name: 'Lesotho', flag: '🇱🇸', prefix: '266' },
  LT: { name: 'Lithuania', flag: '🇱🇹', prefix: '370' },
  LU: { name: 'Luxembourg', flag: '🇱🇺', prefix: '352' },
  LV: { name: 'Latvia', flag: '🇱🇻', prefix: '371' },
  LY: { name: 'Libya', flag: '🇱🇾', prefix: '218' },
  MA: { name: 'Morocco', flag: '🇲🇦', prefix: '212' },
  MC: { name: 'Monaco', flag: '🇲🇨', prefix: '377' },
  MD: { name: 'Moldova, Republic of', flag: '🇲🇩', prefix: '373' },
  ME: { name: 'Montenegro', flag: '🇲🇪', prefix: '382' },
  MF: { name: 'Saint Martin (French part)', flag: '🇲🇫', prefix: '590' },
  MG: { name: 'Madagascar', flag: '🇲🇬', prefix: '261' },
  MH: { name: 'Marshall Islands', flag: '🇲🇭', prefix: '692' },
  MK: {
    name: 'Macedonia, the former Yugoslav Republic of',
    flag: '🇲🇰',
    prefix: '389',
  },
  ML: { name: 'Mali', flag: '🇲🇱', prefix: '223' },
  MM: { name: 'Myanmar', flag: '🇲🇲', prefix: '95' },
  MN: { name: 'Mongolia', flag: '🇲🇳', prefix: '976' },
  MO: { name: 'Macao', flag: '🇲🇴', prefix: '853' },
  MP: { name: 'Northern Mariana Islands', flag: '🇲🇵', prefix: '1670' },
  MQ: { name: 'Martinique', flag: '🇲🇶', prefix: '596' },
  MR: { name: 'Mauritania', flag: '🇲🇷', prefix: '222' },
  MS: { name: 'Montserrat', flag: '🇲🇸', prefix: '1664' },
  MT: { name: 'Malta', flag: '🇲🇹', prefix: '356' },
  MU: { name: 'Mauritius', flag: '🇲🇺', prefix: '230' },
  MV: { name: 'Maldives', flag: '🇲🇻', prefix: '960' },
  MW: { name: 'Malawi', flag: '🇲🇼', prefix: '265' },
  MX: { name: 'Mexico', flag: '🇲🇽', prefix: '52' },
  MY: { name: 'Malaysia', flag: '🇲🇾', prefix: '60' },
  MZ: { name: 'Mozambique', flag: '🇲🇿', prefix: '258' },
  NA: { name: 'Namibia', flag: '🇳🇦', prefix: '264' },
  NC: { name: 'New Caledonia', flag: '🇳🇨', prefix: '687' },
  NE: { name: 'Niger', flag: '🇳🇪', prefix: '227' },
  NF: { name: 'Norfolk Island', flag: '🇳🇫', prefix: '672' },
  NG: { name: 'Nigeria', flag: '🇳🇬', prefix: '234' },
  NI: { name: 'Nicaragua', flag: '🇳🇮', prefix: '505' },
  NL: { name: 'Netherlands', flag: '🇳🇱', prefix: '31' },
  NO: { name: 'Norway', flag: '🇳🇴', prefix: '47' },
  NP: { name: 'Nepal', flag: '🇳🇵', prefix: '977' },
  NR: { name: 'Nauru', flag: '🇳🇷', prefix: '674' },
  NU: { name: 'Niue', flag: '🇳🇺', prefix: '683' },
  NZ: { name: 'New Zealand', flag: '🇳🇿', prefix: '64' },
  OM: { name: 'Oman', flag: '🇴🇲', prefix: '968' },
  PA: { name: 'Panama', flag: '🇵🇦', prefix: '507' },
  PE: { name: 'Peru', flag: '🇵🇪', prefix: '51' },
  PF: { name: 'French Polynesia', flag: '🇵🇫', prefix: '689' },
  PG: { name: 'Papua New Guinea', flag: '🇵🇬', prefix: '675' },
  PH: { name: 'Philippines', flag: '🇵🇭', prefix: '63' },
  PK: { name: 'Pakistan', flag: '🇵🇰', prefix: '92' },
  PL: { name: 'Poland', flag: '🇵🇱', prefix: '48' },
  PM: { name: 'Saint Pierre and Miquelon', flag: '🇵🇲', prefix: '508' },
  PN: { name: 'Pitcairn', flag: '🇵🇳', prefix: '64' },
  PR: { name: 'Puerto Rico', flag: '🇵🇷', prefix: '1787' },
  PS: { name: 'Palestine, State of', flag: '🇵🇸', prefix: '970' },
  PT: { name: 'Portugal', flag: '🇵🇹', prefix: '351' },
  PW: { name: 'Palau', flag: '🇵🇼', prefix: '680' },
  PY: { name: 'Paraguay', flag: '🇵🇾', prefix: '595' },
  QA: { name: 'Qatar', flag: '🇶🇦', prefix: '974' },
  RE: { name: 'Réunion', flag: '🇷🇪', prefix: '262' },
  RO: { name: 'Romania', flag: '🇷🇴', prefix: '40' },
  RS: { name: 'Serbia', flag: '🇷🇸', prefix: '381' },
  RU: { name: 'Russian Federation', flag: '🇷🇺', prefix: '7' },
  RW: { name: 'Rwanda', flag: '🇷🇼', prefix: '250' },
  SA: { name: 'Saudi Arabia', flag: '🇸🇦', prefix: '966' },
  SB: { name: 'Solomon Islands', flag: '🇸🇧', prefix: '677' },
  SC: { name: 'Seychelles', flag: '🇸🇨', prefix: '248' },
  SD: { name: 'Sudan', flag: '🇸🇩', prefix: '249' },
  SE: { name: 'Sweden', flag: '🇸🇪', prefix: '46' },
  SG: { name: 'Singapore', flag: '🇸🇬', prefix: '65' },
  SH: {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    flag: '🇸🇭',
    prefix: '290',
  },
  SI: { name: 'Slovenia', flag: '🇸🇮', prefix: '386' },
  SJ: { name: 'Svalbard and Jan Mayen', flag: '🇸🇯', prefix: '47' },
  SK: { name: 'Slovakia', flag: '🇸🇰', prefix: '421' },
  SL: { name: 'Sierra Leone', flag: '🇸🇱', prefix: '232' },
  SM: { name: 'San Marino', flag: '🇸🇲', prefix: '378' },
  SN: { name: 'Senegal', flag: '🇸🇳', prefix: '221' },
  SO: { name: 'Somalia', flag: '🇸🇴', prefix: '252' },
  SR: { name: 'Suriname', flag: '🇸🇷', prefix: '597' },
  SS: { name: 'South Sudan', flag: '🇸🇸', prefix: '211' },
  ST: { name: 'Sao Tome and Principe', flag: '🇸🇹', prefix: '239' },
  SV: { name: 'El Salvador', flag: '🇸🇻', prefix: '503' },
  SX: { name: 'Sint Maarten (Dutch part)', flag: '🇸🇽', prefix: '1721' },
  SY: { name: 'Syrian Arab Republic', flag: '🇸🇾', prefix: '963' },
  SZ: { name: 'Swaziland', flag: '🇸🇿', prefix: '268' },
  TC: { name: 'Turks and Caicos Islands', flag: '🇹🇨', prefix: '1649' },
  TD: { name: 'Chad', flag: '🇹🇩', prefix: '235' },
  TF: { name: 'French Southern Territories', flag: '🇹🇫', prefix: '262' },
  TG: { name: 'Togo', flag: '🇹🇬', prefix: '228' },
  TH: { name: 'Thailand', flag: '🇹🇭', prefix: '66' },
  TJ: { name: 'Tajikistan', flag: '🇹🇯', prefix: '992' },
  TK: { name: 'Tokelau', flag: '🇹🇰', prefix: '690' },
  TL: { name: 'Timor-Leste', flag: '🇹🇱', prefix: '670' },
  TM: { name: 'Turkmenistan', flag: '🇹🇲', prefix: '993' },
  TN: { name: 'Tunisia', flag: '🇹🇳', prefix: '216' },
  TO: { name: 'Tonga', flag: '🇹🇴', prefix: '676' },
  TR: { name: 'Turkey', flag: '🇹🇷', prefix: '90' },
  TT: { name: 'Trinidad and Tobago', flag: '🇹🇹', prefix: '1868' },
  TV: { name: 'Tuvalu', flag: '🇹🇻', prefix: '688' },
  TW: { name: 'Taiwan, Province of China', flag: '🇹🇼', prefix: '886' },
  TZ: { name: 'Tanzania, United Republic of', flag: '🇹🇿', prefix: '255' },
  UA: { name: 'Ukraine', flag: '🇺🇦', prefix: '380' },
  UG: { name: 'Uganda', flag: '🇺🇬', prefix: '256' },
  UM: { name: 'United States Minor Outlying Islands', flag: '🇺🇲', prefix: '1' },
  US: { name: 'United States', flag: '🇺🇸', prefix: '1' },
  UY: { name: 'Uruguay', flag: '🇺🇾', prefix: '598' },
  UZ: { name: 'Uzbekistan', flag: '🇺🇿', prefix: '998' },
  VA: { name: 'Holy See (Vatican City State)', flag: '🇻🇦', prefix: '379' },
  VC: { name: 'Saint Vincent and the Grenadines', flag: '🇻🇨', prefix: '1784' },
  VE: { name: 'Venezuela, Bolivarian Republic of', flag: '🇻🇪', prefix: '58' },
  VG: { name: 'Virgin Islands, British', flag: '🇻🇬', prefix: '1284' },
  VI: { name: 'Virgin Islands, U.S.', flag: '🇻🇮', prefix: '1340' },
  VN: { name: 'Viet Nam', flag: '🇻🇳', prefix: '84' },
  VU: { name: 'Vanuatu', flag: '🇻🇺', prefix: '678' },
  WF: { name: 'Wallis and Futuna', flag: '🇼🇫', prefix: '681' },
  WS: { name: 'Samoa', flag: '🇼🇸', prefix: '685' },
  XK: { name: 'Kosovo', flag: '🇽🇰', prefix: '383' },
  YE: { name: 'Yemen', flag: '🇾🇪', prefix: '967' },
  YT: { name: 'Mayotte', flag: '🇾🇹', prefix: '262' },
  ZA: { name: 'South Africa', flag: '🇿🇦', prefix: '27' },
  ZM: { name: 'Zambia', flag: '🇿🇲', prefix: '260' },
  ZW: { name: 'Zimbabwe', flag: '🇿🇼', prefix: '263' },
};

/**
 * Auth0 SDK country code structure from TransactionMembersOnLoginId
 */
export interface Auth0CountryCode {
  code: string; // Country code like "IN", "US"
  prefix: string; // Phone prefix like "91", "1"
}

/**
 * Alternative structure that might be in mock data or different SDK versions
 */
export interface Auth0CountryCodeAlt {
  countryCode: string;
  countryPrefix: string;
}

export interface CountryCodePickerData {
  name: string;
  code: string;
  dialCode: string;
  flag: string;
}

export function transformAuth0CountryCode(
  countryCode: string | null | undefined,
  countryPrefix?: string | null | undefined,
): CountryCodePickerData | undefined {
  if (!countryCode) {
    return undefined;
  }

  const countryInfo = COUNTRY_DATA[countryCode];

  if (!countryInfo) {
    // Fallback for unknown country codes
    return {
      name: `Country ${countryCode}`,
      code: countryCode,
      dialCode: countryPrefix ? `+${countryPrefix}` : '+??',
      flag: '🏳️', // Generic flag
    };
  }

  return {
    name: countryInfo.name,
    code: countryCode,
    dialCode: countryPrefix ? `+${countryPrefix}` : `+${countryInfo.prefix}`,
    flag: countryInfo.flag,
  };
}

/**
 * Checks if country picker should be shown - only when phone is the ONLY identifier option
 * @param identifiers - Array of allowed identifier types
 * @returns boolean indicating if country picker should be displayed
 */
export function isPhoneNumberSupported(identifiers: string[]): boolean {
  // Show country picker only when phone is the sole identifier option
  return (
    identifiers.length === 1 &&
    identifiers.some((identifier) => identifier.toLowerCase().includes('phone'))
  );
}

export function getCountryName(countryCode: string): string {
  return COUNTRY_DATA[countryCode]?.name || `Country ${countryCode}`;
}

export function getCountryFlag(countryCode: string): string {
  return COUNTRY_DATA[countryCode]?.flag || '🏳️';
}

export function getCountryPrefix(countryCode: string): string | undefined {
  return COUNTRY_DATA[countryCode]?.prefix;
}

export interface PhoneCountryInfo {
  countryCode: string;
  prefix: string;
}

/**
 * Extracts country code from a phone number string
 * Supports formats: +33 6 04 67 77 28, +33604677728, +33 604 677 728, etc.
 *
 * @param phoneNumber - The phone number string (with or without + prefix)
 * @returns Object with countryCode (ISO 3166-1 alpha-2) and prefix, or null if not found
 *
 * @example
 * getCountryFromPhoneNumber('+33 6 04 67 77 28') // { countryCode: 'FR', prefix: '33' }
 * getCountryFromPhoneNumber('+32 470 12 34 56') // { countryCode: 'BE', prefix: '32' }
 * getCountryFromPhoneNumber('+1 555 123 4567') // { countryCode: 'US', prefix: '1' }
 */
export function getCountryFromPhoneNumber(
  phoneNumber: string | null | undefined,
): PhoneCountryInfo | null {
  if (!phoneNumber) {
    return null;
  }

  // Remove all non-digit characters except leading +
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');

  // Remove leading + if present
  const digits = cleaned.startsWith('+') ? cleaned.slice(1) : cleaned;

  if (!digits) {
    return null;
  }

  // Build a map from prefix to country code for lookup
  // Try to match prefix from longest to shortest (4 digits down to 1)
  for (let len = 4; len >= 1; len--) {
    const prefix = digits.slice(0, len);

    // Find country with matching prefix
    for (const [code, data] of Object.entries(COUNTRY_DATA)) {
      if (data.prefix === prefix) {
        return { countryCode: code, prefix };
      }
    }
  }

  return null;
}
